<div class="thumbnail" [ngClass]="{ 'selected-thumbnail': isSelected }">
  <span *ngIf="masterclass.category" class="thumbnail-category">#{{ masterclass.category | capitalizeFirst }}</span>
  <img class="thumbnail-image" [src]="masterclass.speaker?.photoUrl ?? '../../../assets/images/masterclasses/question-mark-ssbu.png'" />
</div>
